import { http } from './http'

import type {
  AddTechpackToFolderDTO,
  CreateSharedFolderDTO,
  PatchSharedFolderDTO,
  SharedFolder
} from '../store/sharedFolders/sharedFolders.types'
import { SharedFoldersApi } from '../generated'

export async function createFolder(folder: CreateSharedFolderDTO): Promise<{ data: unknown }> {
  const data = await http.post<unknown>('v2/shared-folders', folder)
  return data
}

export async function getSharedFolders(): Promise<{ data: unknown }> {
  const data = await http.get<unknown>(`v2/shared-folders`)
  return data
}

export async function patchSharedFolder(folderId: string, dto?: PatchSharedFolderDTO): Promise<{ data: unknown }> {
  const data = await http.patch<unknown>(`v2/shared-folders/${folderId}`, dto)
  return data
}

export async function addTechpack(
  folderId: string,
  techpackId: string,
  updates?: AddTechpackToFolderDTO
): Promise<SharedFolder> {
  const { data } = await http.patch<AddTechpackToFolderDTO & { techpacks: Array<string> }, { data: SharedFolder }>(
    `v2/shared-folders/${folderId}`,
    {
      ...updates,
      techpacks: [techpackId]
    }
  )
  return data
}

export const sharedFoldersApi = new SharedFoldersApi(undefined, `${http.http.defaults.baseURL}/v2`, http.http)
